import watchAdminContentRequested from './getAdminContentSaga';

export default [
  watchAdminContentRequested(),
];
